import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Container = styled(Wrapper)`
  display: flex;
  flex-direction: column;
`;
export const DiscListContainer = styled.ul`
  list-style-type: disc;
`;

export const NumberListContainer = styled.ol``;

export const AlphaListContainer = styled.ol`
  list-style-type: lower-alpha;
`;

export const ItemContainer = styled.li`
  letter-spacing: -0.3px;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
`;
